module.exports = __webpack_public_path__ + "img/banner1.ce13a043.webp";